module.exports = __webpack_public_path__ + "img/airplane.e549f044.svg";